import { render, staticRenderFns } from "./OverviewAirportLayout.vue?vue&type=template&id=16f2c0fe&"
import script from "./OverviewAirportLayout.vue?vue&type=script&lang=js&"
export * from "./OverviewAirportLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports